export const scrollSlowingIntensity = [
  'veryLow',
  'low',
  'moderate',
  'high',
  'veryHigh',
  'extreme',
  'stopScrolling',
] as const

export type ScrollSlowingIntensity = (typeof scrollSlowingIntensity)[number]
